import {WpEtEnrollment} from "./wp-et-enrollment.model";
import {WpPerson} from "./wp-person.model";

export class ContactHistory{
  constructor(
    public id?: number,
    public contactDt?: any,
    public contactMethodCd?: string,
    public contactReasonCd?: string,
    public contactedBy?: any,
    public contactOutcomeCd?: string,
    public notes?: string,
    public recordVersion?:number,
    public wpPersonId?: number,
  ){
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/model/contactHistory.model.ts